import React, { Component } from 'react'
import axios from 'axios'
import { Button, FieldGroup, Notification, Heading, BodyText, LoadingSpinner } from '@lmig/lmds-react'
import Information1099 from './FormGroup/1099Information'
import AdditionalComments from './FormComponents/AdditionalComments'
import ContactInfo from './FormGroup/ContactInfo'
import Address from './FormGroup/Address'
import SupportingDocs from './FormGroup/SupportingDocs'
import Error from './FormError/Error'
import './FormCSS/Form.css'

class Request1099 extends Component {
  state = {
    hasInvalidFields: false,
    missingFields: [],
    attachmentList: [],
    isError: false,
    isLoading: false,
    loadingStatus: '',
    request1099: {
      taxID: '',
      recipientName: '',
      additionalRecipients: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      zipcode: '',
      country: 'United States',
      requestersName: '',
      phoneNumber: '',
      email: '',
      comments: '',
    },
  }

  // handles all state changes outside of the recipient names and attachments
  onChangeValueHandler = val => {
    let inputName = val.target.name
    let inputVal = val.target.value
    let requestState = this.state.request1099
    requestState[inputName] = inputVal
    this.setState({ request1099: requestState })
  }

  // handles Additional Recipient state change
  onChangeAdditionalRecipient = val => {
    let requestState = this.state.request1099
    requestState['additionalRecipients'] = val.toString()
    this.setState({ requestReplacementCheck: requestState })
  }

  handleSubmit = () => {
    const missingFields = this.validateAllFields()
    const hasInvalidFields = missingFields.length !== 0
    this.setState({ hasInvalidFields, missingFields })
    if (hasInvalidFields) {
      window.scroll(0, 0)
    } else {
      this.populateTicket()
    }
  }

  //validates which fields need to be addressed
  validateAllFields() {
    let missingFields = []
    if (this.state.request1099.taxID === '') {
      missingFields.push('Tax ID number needed.')
    }
    if (this.state.request1099.taxID.length < 4) {
      missingFields.push('Tax ID needs to be 4 digits in length.')
    }
    if (this.state.request1099.recipientName === '') {
      missingFields.push('Recipient name needed.')
    }
    if (this.state.request1099.address1 === '') {
      missingFields.push('Street Address is needed.')
    }
    if (this.state.request1099.city === '') {
      missingFields.push('City is needed.')
    }
    if (this.state.request1099.zipcode === '') {
      missingFields.push('Zipcode is needed.')
    }
    if (this.state.request1099.zipcode.length > 5 && this.state.request1099.zipcode.length < 10) {
      missingFields.push('Zipcode is incomplete.')
    }
    if (this.state.request1099.state === '') {
      missingFields.push('State is needed.')
    }
    if (this.state.request1099.requestersName === '') {
      missingFields.push('Requester name is needed.')
    }
    if (this.state.request1099.phoneNumber === '') {
      missingFields.push('Telephone number is needed.')
    }
    if (this.state.request1099.phoneNumber !== '' && this.state.request1099.phoneNumber.length !== 14) {
      missingFields.push('Phone number in incomplete.')
    }
    if (this.state.request1099.email !== '' && this.isValidEmail(this.state.request1099.email) === false) {
      missingFields.push('Please enter a valid email with @ symbol.')
    }
    return missingFields
  }

  isValidEmail(emailPassed) {
    const re = /\S+@\S+\.\S+/
    return re.test(emailPassed)
  }

  // this will create a ticket and upload any attachments if there are any
  populateTicket() {
    let postUrl = '/api/createJiraTicket/DNR'
    const formData = new FormData()
    formData.append('requestData', JSON.stringify(this.state.request1099))
    // add files to data form
    this.state.attachmentList.map(aFile => formData.append('files', aFile))
    this.setState({ isLoading: true, loadingStatus: 'Creating request...' })
    axios({
      method: 'post',
      url: postUrl,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(result => {
        // if email sent.
        if (result.status === 201) {
          this.setState({ isLoading: false, loadingStatus: '' })
          window.open('/confirmationPage/3', '_self')
        } else {
          // error occurred that isn't a network error
          this.setState({ isLoading: false, loadingStatus: '', isError: true })
        }
      })
      .catch(error => {
        this.setState({ isLoading: false, loadingStatus: '', isError: true })
        console.error('error: ', error)
      })
  }

  //adds attachments to list
  handleAttachments = filesToPass => {
    this.setState({ attachmentList: filesToPass })
  }

  // handle state change from the closeModal function in Error.js
  handleErrorPopup = isOpen => {
    this.setState({ isError: isOpen })
  }

  render() {
    let listOfMVs = this.state.missingFields.map((v, index) => (
      <li className='notification-bullet' key={index}>
        {v}
      </li>
    ))
    return (
      <>
        {this.state.isError && <Error isError={this.state.isError} update={this.handleErrorPopup} />}
        {this.state.isLoading && <LoadingSpinner />}
        <form>
          <Heading type={'h3-light'}>Request a 1099 Form</Heading>
          <BodyText type={'lead'}>
            Notify our Treasury Tax team that you did not receive a 1099 and need one sent to you.
          </BodyText>
          {this.state.hasInvalidFields && (
            <Notification className='notification-window' type='error'>
              <h6>Please address the following issues</h6>
              <br />
              <ul>{listOfMVs}</ul>
            </Notification>
          )}
          <br />
          <FieldGroup id='fieldgroup--request1099' disableMargins='top'>
            <div className='formBorder'>
              <div className='borderMargin'>
                <Information1099
                  additionalRecChange={this.onChangeAdditionalRecipient}
                  onChangeHandler={this.onChangeValueHandler}
                  taxIDRequired
                />
                <br />
                <Address onChangeHandler={this.onChangeValueHandler} />
                <br />
                <ContactInfo onChangeHandler={this.onChangeValueHandler} />
                <br />
                <SupportingDocs
                  attachmentsList={this.handleAttachments}
                  canComment
                  maxFileSize={'20MB'}
                  maxTotalFileSize={'400MB'}
                />
                <br />
                <AdditionalComments onChangeHandler={this.onChangeValueHandler} />
                <br />
                <br />
                <Button
                  variant='primary'
                  id='test'
                  size='large'
                  onClick={this.handleSubmit}
                  disabled={this.state.isLoading}
                >
                  {this.state.isLoading ? this.state.loadingStatus : 'Submit Request'}
                </Button>
              </div>
            </div>
          </FieldGroup>
        </form>
      </>
    )
  }
}

export default Request1099
